import React, { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setLoading, setModule } from "../../store/actions/commonAction";
import CommonDataService from "../../services/common";
import {
	AllowedUsergroup,
	GetIndexByValue,
	CDNWebsite,
} from "../../helpers/common";

import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import ReplayIcon from "@mui/icons-material/Replay";
import Divider from "@mui/material/Divider";
import SaveIcon from "@mui/icons-material/Save";
import Alert from "@mui/material/Alert";
import PhotoCamera from "@mui/icons-material/PhotoCamera";

import MessageDialog from "../MessageDialog";
import http from "../../http";

export default function HeaderImage({ placeholder }) {
	const dispatch = useDispatch();

	const company = useSelector((state) => state.commonReducer.user.company);
	const userGroup = useSelector((state) => state.commonReducer.user.usergroup);
	const token = useSelector((state) => state.commonReducer.user.token);
	const loading = useSelector((state) => state.commonReducer.loading);

	const [message, setMessage] = useState("");
	const [error, setError] = useState(false);
	const [success, setSuccess] = useState(false);

	const [thumbPath, setThumbPath] = useState([]);
	const [offices, setOffices] = useState([]);
	const [idOffice, setIdOffice] = useState(company);
	const [idOfficeAC, setIdOfficeAC] = useState(null);
	const [image, setImage] = useState("");
	const [reset, setReset] = useState(false);

	const LoadSelect = useCallback(() => {
		dispatch(setLoading(true));

		dispatch(setModule("Header Image"));

		CommonDataService.GetHeaderImage(idOffice).then((res) => {
			setThumbPath(CDNWebsite() + res.data);
			dispatch(setLoading(false));
		});

		if (AllowedUsergroup(userGroup, "superuser-website")) {
			CommonDataService.getOffices().then((res) => {
				setOffices(res.data);
			});
		}
	}, [dispatch, idOffice, userGroup]);

	useEffect(() => {
		setIdOfficeAC(GetIndexByValue(offices, idOffice));
	}, [offices, idOffice]);

	useEffect(() => {
		LoadSelect();
	}, [LoadSelect]);

	const handleSubmit = (event) => {
		event.preventDefault();

		const data = new FormData(event.currentTarget);
		data.append("image", image);
		data.append("IdOffice", idOffice);
		data.append("Reset", reset);

		dispatch(setLoading(true));
		setSuccess(false);

		http
			.post("/headerimage", data, {
				headers: {
					"Content-Type": "multipart/form-data",
					Authorization: "Bearer " + token,
				},
			})
			.then((res) => {
				dispatch(setLoading(false));
				setThumbPath(CDNWebsite() + res.data);
				setSuccess(true);
			})
			.catch(function (error) {
				setMessage(error.response.data.message);
				setError(true);
				dispatch(setLoading(false));
			});
	};

	return (
		<Grid container spacing={3}>
			<Grid item xs={12}>
				<MessageDialog show={error} message={message} dialogClose={setError} />

				<Paper
					sx={{
						p: 2,
						display: "flex",
						flexDirection: "column",
					}}
				>
					{success && <Alert severity="success">Success</Alert>}
					<Box component="form" onSubmit={(e) => handleSubmit(e)}>
						<Typography variant="h5">Set Header Image</Typography>

						<Grid container spacing={3}>
							{AllowedUsergroup(userGroup, "superuser-website") && (
								<Grid item xs={12} sm={12}>
									<Autocomplete
										id="id_office"
										name="id_office"
										options={offices}
										getOptionLabel={(option) => option.name}
										isOptionEqualToValue={(option, value) =>
											option.value === value.value
										}
										fullWidth={true}
										onChange={(e, val) => {
											if (val !== null) {
												setIdOffice(val.id);
											} else {
												setIdOffice("");
											}
										}}
										value={idOfficeAC}
										sx={{ minWidth: 100 }}
										renderInput={(params) => (
											<TextField
												variant="standard"
												{...params}
												label="Office"
											/>
										)}
									/>
								</Grid>
							)}

							<Grid item xs={12} sm={12}>
								<div>
									<img alt="" width="500" src={thumbPath} />
								</div>
								<Button
									variant="outlined"
									startIcon={<PhotoCamera />}
									component="label"
								>
									Select Image
									<input
										hidden
										onChange={(e) => {
											setReset(false);
											setImage(e.target.files[0]);
											const file = e.target.files[0];
											let reader = new FileReader();
											reader.readAsDataURL(file);
											reader.onload = () => {
												setThumbPath(reader.result);
											};
										}}
										accept="image/*"
										multiple
										type="file"
									/>
								</Button>

								<Button
									variant="outlined"
									onClick={() => {
										setReset(true);
										setSuccess(false);
										setThumbPath(CDNWebsite() + "img/slide6.jpg");
									}}
									startIcon={<ReplayIcon />}
									sx={{ ml: 1 }}
								>
									Reset Image
								</Button>
							</Grid>

							<Grid item xs={12} sm={12}>
								<Divider />
							</Grid>

							<Grid item xs={12} sm={12}>
								<Button
									type="submit"
									variant="contained"
									disabled={loading}
									startIcon={<SaveIcon />}
								>
									{loading && (
										<span>
											<span className="spinner-border spinner-border-sm"></span>
											&nbsp;
										</span>
									)}
									<span> {loading ? "Please Wait" : "Save"}</span>
								</Button>
							</Grid>
						</Grid>
					</Box>
				</Paper>
			</Grid>
		</Grid>
	);
}
